import React, { Component } from 'react';
import { loadReCaptcha } from 'react-recaptcha-v3';
import { CAPTCHA_SITE_KEY } from './config/constants';
import Routes from './routes';
import '../node_modules/video-react/dist/video-react.css';
import './style.css';

class App extends Component {
	componentDidMount(prop) {
		loadReCaptcha(CAPTCHA_SITE_KEY);
	}

	render() {
		return <Routes />;
	}
}

export default App;
